<template>
  <div class="location-progress-chart">
    <div class="chart-header">
      <h4 class="chart-title">Location Progress</h4>
      <div class="chart-actions">
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'bar' }"
          @click="selectedView = 'bar'"
          aria-label="Bar chart view"
        >
          <i class="fa fa-bar-chart" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'pie' }"
          @click="selectedView = 'pie'"
          aria-label="Pie chart view"
        >
          <i class="fa fa-pie-chart" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'list' }"
          @click="selectedView = 'list'"
          aria-label="List view"
        >
          <i class="fa fa-list" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'download' }"
          @click="selectedView = 'download', downFunc()"
          aria-label="Download chart"
        >
          <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="chart-content-area">
      <LocationProgressBarChart
        v-if="selectedView === 'bar' || selectedView === 'download'"
        :locationNames="locationNames"
        :locations="locations"
        :seriesValues="seriesValues"
        :seriesName="seriesName"
      />
      <LocationProgressPieChart
        v-if="selectedView === 'pie'"
        :locationNames="locations"
        :seriesValues="seriesValues"
      />
      <LocationProgressList
        v-if="selectedView === 'list'"
        :locations="locations"
        :locationNames="locationNames"
        :seriesValues="seriesValues"
      />
    </div>
  </div>
</template>
<script>
import LocationProgressBarChart from '@/components/enterpriseadmin/location_progress_barchart.vue';
import LocationProgressList from '@/components/enterpriseadmin/location_progress_list.vue';
import LocationProgressPieChart from '@/components/enterpriseadmin/location_progress_piechart.vue';
import axios from 'axios';

export default {
  props: {
    locationNames: {
      type: Array,
      default() {
        return [];
      },
    },
    seriesValues: {
      type: Array,
      default() {
        return [];
      },
    },
    seriesName: {
      type: String,
      default: 'Mentee Progress',
    },
    locations: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedView: 'bar',
			apiUrl: process.env.API_ENDPOINT,
    };
  },
  components: {
    LocationProgressBarChart,
    LocationProgressList,
    LocationProgressPieChart,
  },
	methods: {
		downFunc() {
			axios.get('/enterprise-admin-locationprogress-csv')
			.then(response => {
				var fileName = response.data;
				if (fileName) {
					var url = this.apiUrl + '/custom/csv-view/' + fileName + '/Location-Progress';
					window.location.href = url;
				}
			})
			.catch(error => {

			});
		},
	},
};
</script>
<style scoped>
.location-progress-chart {
  width: 100%;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px 12px 8px 12px;
  border-bottom: 1px solid #e5e7eb;
}

.chart-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.1;
  color: #1f2937;
}

.chart-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 3px;
}

.chart-action-btn {
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #4b5563;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.chart-action-btn.active {
  color: #111827;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #d1d5db;
}

.chart-action-btn i {
  font-size: 12px;
}

.chart-content-area {
  height: 100%;
  overflow: auto;
	margin-right: 20px;
	padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/location_progress_chart.vue